import { Component, Input, OnChanges, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IUser } from '../../shared/models/user.model';
import { PaymentV2Service, StorageService, UtilService, VariablesService, VwoService } from '../../shared/services';
import { MainComponent } from '../payment/components';
import { PaymentUtilService } from '../payment/services';
import { PaymentOtdComponent } from '../payment-otd/components/payment-otd/payment-otd.component';

@Component({
  selector: 'app-story-payment',
  templateUrl: './story-payment.component.html',
  styleUrls: ['./story-payment.component.scss']
})
export class StoryPaymentComponent implements OnInit, OnChanges {

  @Input() config;
  upiOptionData;
  params;
  isMobile;
  userData: IUser;
  @ViewChild('paymentRef') paymentRef: MainComponent;
  @ViewChild(PaymentOtdComponent) public paymentOtd: PaymentOtdComponent;
  @ViewChild('paymentModule', { static: true }) public paymentMod: TemplateRef<any>;


  constructor(
    private actRout: ActivatedRoute,
    private paymentUtilService: PaymentUtilService,
    public vars: VariablesService,
    public utilService: UtilService,
    public vwo: VwoService,
    private storageService: StorageService,
    public paymentV2: PaymentV2Service,
    private router: Router
  ) { }

  ngOnChanges(): void {
    this.config = Object.assign({
      daysLeft: true,
      supporters: true,
      header: true,
      showBeneficiary: false,
      paymentHeader: true,
      inputFields: true,
      assured: true,
      topContent: true,
      origin: 's'
    }, this.config);
  }

  ngOnInit(): void {
    this.isMobile = this.utilService.isMobile();
    this.params = this.actRout.snapshot.queryParams;
    if (this.actRout.snapshot.queryParams.st === 'f') {
      this.paymentUtilService.isSubmitted.next(true);
    }
    this.vars.onUpiOptionClick.subscribe(res => {
      this.upiOptionData = res;
      const storyPayment = document.getElementById('storyPayment');
      storyPayment.classList.add(res.panelClass);
      setTimeout(() => storyPayment.classList.remove(res.panelClass), 500);
    });
    this.userData = this.utilService.getUserData();
    this.vars.otdpayment.subscribe(res => {
      if (res) {
        this.submitOrderForOtdCard(res);
      }
    })
  }

  setCurrency(data) {
    this.paymentRef.getCurrencyFromHeader(data);
  }
  
  submitOrderForOtdCard(res) {
    this.paymentOtd.config.recentPayMode = res?.paymode;
    this.paymentOtd.setLastPayMode('INR');
    this.paymentOtd.setAmount(res?.amount);
    if (this.params?.utm_source?.match('otd_calling')) {
      this.router.navigate([], {
      queryParams: { ministoryquiz: 'true' },
      queryParamsHandling: 'merge'
      });
    }
    this.paymentOtd.createCart('lastPay');
  }

}
